import { InvoiceTransModel } from "./invoice-trans.model";
import { PaymentDetailsModel } from "./invoice-model";

export class InvoiceReceiptModel {
    id: number
    invoice_no: number
    transactions: InvoiceTransModel[]
    payment_dets: PaymentDetailsModel[]
    pet_no: number
    client_no: number
    inv_date: string
    client_signature:number
    file_id:number

    constructor(
        id: number,
        invoice_no: number,
        transactions: InvoiceTransModel[],
        payment_dets: PaymentDetailsModel[],
        pet_no: number,
        client_no: number,
        inv_date: string,
        client_signature:number,
        file_id:number
    ) {
        this.id = id
        this.invoice_no = invoice_no
        this.transactions = transactions
        this.payment_dets = payment_dets
        this.pet_no = pet_no
        this.client_no = client_no
        this.inv_date = inv_date
        this.client_signature = client_signature
        this.file_id = file_id
    }
}
 